document.addEventListener('DOMContentLoaded', function () {
	const { referrer } = document;
	let isServiceNowSelected = false; // Track whether ServiceNow option was selected
	const { __ } = wp.i18n;
	const responseContainer = document.getElementById('contact-response');
	const requiredInputs = document.querySelectorAll('#contact-form input[required]');
	const registerButton = document.getElementById('contact-form-button');
	const contactFormButton = document.getElementById('contact-form-button');
	function ValidateEmail(input) {
		const validRegex = /^\w+([.-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/;
		if (input.match(validRegex)) {
			return true;
		}
	}
	function checkEmptyInputs() {
		let empty = false;
		requiredInputs.forEach(function (input) {
			const val = input.value.trim();
			if (val.length === 0 || typeof val === 'undefined') {
				empty = true;
			} else if (input.type === 'email') {
				if (!ValidateEmail(val)) {
					empty = true;
					const spanElement = document.createElement('p');
					const textNode = document.createTextNode(
						__('Please enter a valid email address', 'infobeans-2023'),
					);
					spanElement.classList.add('error');
					spanElement.appendChild(textNode);
					if (input.nextElementSibling === null) {
						input.insertAdjacentElement('afterend', spanElement);
					}
				} else if (input.nextElementSibling !== null) {
					input.nextElementSibling.remove();
				}
			}
		});
		const interest = document.getElementById('interest');
		const interestValue = interest.options[interest.selectedIndex].value;
		if (
			interestValue.length === 0 ||
			typeof interestValue === 'undefined' ||
			interestValue === ''
		) {
			empty = true;
		}
		if (empty) {
			registerButton.setAttribute('disabled', 'disabled');
		} else {
			registerButton.removeAttribute('disabled');
		}
		return empty;
	}
	if (requiredInputs) {
		requiredInputs.forEach(function (input) {
			input.addEventListener('keyup', checkEmptyInputs);
		});
	}
	const selectElement = document.getElementById('interest');
	if (selectElement) {
		const subjectElement = document.getElementById('subject');
		const emailElement = document.getElementById('to_email');
		selectElement.addEventListener('change', function () {
			const checkInputs = checkEmptyInputs(requiredInputs);
			const interestValue = this.options[this.selectedIndex].getAttribute('data-value');
			const email = this.options[this.selectedIndex].getAttribute('data-email');
			const subject = this.options[this.selectedIndex].getAttribute('data-subject');
			const interestCheck = this.options[this.selectedIndex].getAttribute('data-check');
			const companyDiv = document.getElementById('company_check');
			if (typeof interestValue === 'undefined' || interestValue === '') {
				registerButton.setAttribute('disabled', 'disabled');
			} else if (checkInputs === true) {
				registerButton.setAttribute('disabled', 'disabled');
			} else {
				registerButton.removeAttribute('disabled');
			}
			const otherElements = document.querySelectorAll('.checkbox-flex');
			otherElements.forEach(function (ele) {
				const other = ele;
				other.style.display = 'none';
			});
			const targetElement = document.getElementById(interestValue);
			if (targetElement) {
				targetElement.style.display = 'block';
			}
			subjectElement.value = subject;
			emailElement.value = email;
			if (companyDiv.children.length > 0 && interestCheck) {
				if (interestCheck === 'true') {
					for (let i = 0; i < companyDiv.children.length; i += 1) {
						const cc = companyDiv.children[i];
						cc.style.display = 'none';
					}
				} else {
					for (let i = 0; i < companyDiv.children.length; i += 1) {
						const cc = companyDiv.children[i];
						cc.style.display = 'block';
					}
				}
			}
			if (companyDiv.children.length > 0 && interestCheck === null) {
				for (let i = 0; i < companyDiv.children.length; i += 1) {
					const cc = companyDiv.children[i];
					cc.style.display = 'block';
				}
			}
		});
	}
	if (referrer.includes('servicenow-world-forum-dallas')) {
		const selectBox = document.getElementById('interest');
		if (selectBox) {
			const desiredOption = selectBox.querySelector(
				'option[value="InfoBeans & agineo Mixer: Networking Happy Hour"]',
			);
			if (desiredOption) {
				desiredOption.selected = true;
				// Trigger the change event to handle any related logic
				selectBox.dispatchEvent(new Event('change'));
				isServiceNowSelected = true; // Mark as selected
			}
		}
		return; // Exit here if we found the URL, so "Offerings" doesn't override it
	}
	if (!isServiceNowSelected) {
		const keyValuePair = {
			'rapid-experimentation': 'Design',
			'ai-and-gen-ai': 'AI and Gen AI',
			'ux-ui-design': 'Design',
			'application-development': 'Engineering',
			cloud: 'Engineering',
			'front-end': 'Engineering',
			'web3-and-blockchain': 'Blockchain',
			'application-modernization': 'Engineering',
			devops: 'DevOps & QA',
			'sla-based-managed-services': 'Managed Services',
			salesforce: 'Salesforce',
			servicenow: 'ServiceNow',
			'microsoft-azure': 'Other Platforms',
			creatio: 'Other Platforms',
			mendix: 'Other Platforms',
			automattic: 'Other Platforms',
			'qa-automation': 'DevOps and QA',
			'managed-support': 'Managed Services',
			spacewarp: 'ServiceNow',
			lighthouse: 'Salesforce',
			'ultra-field-history-tracker': 'Salesforce',
			'nft-marketplace': 'Blockchain',
			stanza: 'Stanza',
			'data-mind-ai-storage-optimizer': 'Engineering',
		};
		const [key, value] = Object.entries(keyValuePair).find(([k]) => referrer.includes(k)) || [];
		if (key) {
			const selectBox = document.getElementById('interest');
			if (selectBox) {
				selectBox.value = 'Offerings';
				const selectedOption = selectBox.querySelector('option[value="Offerings"]');
				if (selectedOption) {
					const dataValue = selectedOption.getAttribute('data-value');
					const element = document.getElementById(dataValue);
					if (element) {
						element.style.display = 'block';
					}
				}
				const checkbox = document.querySelector(`input.contact-checkbox[value="${value}"]`);
				if (checkbox) {
					// Set the checkbox to be checked
					checkbox.checked = true;
				}
			}
			return;
		}
	}

	if (contactFormButton) {
		contactFormButton.addEventListener('click', function (event) {
			event.preventDefault();
			const contactForm = document.getElementById('contact-form');
			const contactButton = document.getElementById('contact-form-button');
			const subjectElement = document.getElementById('subject');
			const emailElement = document.getElementById('to_email');
			const recaptchaToken = document.getElementById('recaptcha_token');
			contactButton.textContent = 'Sending...';
			const kvpairs = [];
			for (let i = 0; i < contactForm.elements.length; i += 1) {
				const formEle = contactForm.elements[i];
				if (formEle.type !== 'checkbox' && formEle.type !== 'button') {
					const formValue = formEle.value.replace(/\n/g, '<br />');
					kvpairs.push(`${encodeURIComponent(formEle.name)}=${encodeURIComponent(formValue)}`);
				}
			}
			let queryString = kvpairs.join('&');
			const checkedCheckbox = document.querySelectorAll('.contact-checkbox:checked');
			const values = [];
			checkedCheckbox.forEach(function (checkbox) {
				values.push(checkbox.value);
			});
			if (values.length > 0) {
				const checkboxString = values.join(',');
				queryString = `${queryString}&area_interests=${checkboxString}`;
			}
			if (responseContainer.children.length > 0) {
				responseContainer.children[0].remove();
			}
			if (recaptchaToken) {
				queryString = `${queryString}&recaptcha_token=${recaptchaToken.value}`;
			}
			// Create a new XMLHttpRequest object
			const xhr = new XMLHttpRequest();
			xhr.open('POST', ajaxload_params.ajaxurl, true); //eslint-disable-line
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.onload = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const response = JSON.parse(xhr.responseText);
					const successIcon = document.createElement('img');
					const siteURL = window.location.origin;
					successIcon.setAttribute(
						'src',
						`${siteURL}/wp-content/client-mu-plugins/ib-newsletter-signup/dist/static/assets/icon-checkmark.svg`,
					);
					successIcon.setAttribute('alt', 'Success Icon');
					const successMessage = document.createElement('p');
					if (response.success) {
						successMessage.className = 'contact-success p2';
						successMessage.appendChild(successIcon);
						const messageText = document.createTextNode(response.message);
						successMessage.appendChild(messageText);
					} else {
						successMessage.className = 'contact-error p2';
						const messageText = document.createTextNode(response.message);
						successMessage.appendChild(messageText);
					}
					responseContainer.style.display = 'block';
					responseContainer.insertAdjacentElement('afterbegin', successMessage);
					contactButton.textContent = 'Send Message';
					contactForm.reset();
					registerButton.setAttribute('disabled', 'disabled');
					subjectElement.value = '';
					emailElement.value = '';
					setTimeout(function () {
						window.location.reload();
					}, 5000);
				}
			};
			// Send the AJAX request
			xhr.send(`action=contact_form_sent&${queryString}`); //eslint-disable-line
		});
	}

	grecaptcha.ready(function () { //eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'contact_us_form' }) //eslint-disable-line
			.then(function (token) {
				// Attach the token as a hidden field to the form
				const tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;
				const recaptchaContainer = document.getElementById('contact-recaptcha-container');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
			});
	});
	const accordionHeaders = document.querySelectorAll('.accordion-header');
	if (accordionHeaders) {
		accordionHeaders.forEach(header => {
			header.addEventListener('click', () => {
				const accordionItem = header.parentElement;
				accordionItem.classList.toggle('active');
			});
		});
	}
});
